export enum EDocumentType {
    CPF = "CPF",
    CNPJ = "CNPJ",
    RG = "RG",
}